import React from "react";
import MUIStarIcon from "@mui/icons-material/Star";

export default function StarIcon() {
  return (
    <>
      {" "}
      <MUIStarIcon
        fontSize="small"
        sx={{
          verticalAlign: "sub",
          color: "gold",
          stroke: "#D3B300",
          strokeWidth: 0.5,
        }}
      />
    </>
  );
}
